import axios from 'axios';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Legacy localStorage token — kept as Authorization header fallback while old sessions
// expire naturally (max 30 days). New logins rely solely on the httpOnly cookie.
const getHeaders = () => {
  const token = localStorage.getItem('da_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Read the readable CSRF cookie set by the server after login / /auth/me.
const getCsrfToken = () => {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
};

const _SAFE = new Set(['get', 'head', 'options']);

const request = (method, url, data, params, extra = {}) => {
  const headers = { ...getHeaders() };
  // Attach CSRF token for every state-changing request
  if (!_SAFE.has(method.toLowerCase())) {
    const csrf = getCsrfToken();
    if (csrf) headers['X-CSRF-Token'] = csrf;
  }
  return axios({
    method, url: `${BASE}${url}`, data, params,
    headers,
    withCredentials: true,
    ...extra,
  });
};

export const api = {
  get: (url, params) => request('get', url, undefined, params),
  post: (url, data) => request('post', url, data),
  put: (url, data) => request('put', url, data),
  delete: (url) => request('delete', url),
  upload: (url, formData) => {
    const csrf = getCsrfToken();
    return axios.post(`${BASE}${url}`, formData, {
      headers: {
        ...getHeaders(),
        'Content-Type': 'multipart/form-data',
        ...(csrf ? { 'X-CSRF-Token': csrf } : {}),
      },
      withCredentials: true,
    });
  },
};
